import React from "react";
import {
  User,
  FileText,
  Heart,
  Search,
  Target,
  Shield,
} from "lucide-react";

const FeatureCards: React.FC = () => {
  const features = [
    {
      icon: User,
      title: "전문적인 프로필",
      description: "이력서, 포트폴리오, 추천서를 한 곳에서 관리하고 공유하세요",
      color: "from-blue-500 to-blue-600",
    },
    {
      icon: Target,
      title: "AI 추천 시스템",
      description: "당신의 스킬과 경험에 맞는 최적의 채용공고를 추천해드립니다",
      color: "from-purple-500 to-purple-600",
    },
    {
      icon: Search,
      title: "스마트 검색",
      description: "직무, 기술스택, 지역별로 정확한 검색이 가능합니다",
      color: "from-green-500 to-green-600",
    },
    {
      icon: Heart,
      title: "북마크 & 관심목록",
      description: "마음에 드는 채용공고나 인재를 저장하고 관리하세요",
      color: "from-red-500 to-red-600",
    },
    {
      icon: FileText,
      title: "포트폴리오 관리",
      description:
        "프로젝트와 성과를 시각적으로 보여주는 포트폴리오를 만드세요",
      color: "from-orange-500 to-orange-600",
    },
    {
      icon: Shield,
      title: "보안 & 프라이버시",
      description: "개인정보 보호와 안전한 채용 프로세스를 보장합니다",
      color: "from-indigo-500 to-indigo-600",
    },
  ];

  return (
    <div className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            플랫폼의 주요 기능
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            현대적인 채용 플랫폼의 모든 기능을 한 곳에서 경험하세요
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-8 shadow-sm border border-gray-200 hover:shadow-lg transition-shadow group"
            >
              <div
                className={`inline-flex items-center justify-center w-16 h-16 bg-gradient-to-r ${feature.color} rounded-xl mb-6 group-hover:scale-110 transition-transform`}
              >
                <feature.icon className="w-8 h-8 text-white" />
              </div>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {feature.title}
              </h3>

              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FeatureCards;
